<template>
  <div :class="['body_show',state?'body_shows':'']" v-if="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="top">
      <div class="custom-logo" :style="custom_logo"></div>
      <h2>测试者：{{data.nickname}}</h2>
      <h3>{{data.ctime}}</h3>
      <!-- <a @click="reset" v-if="data.past_days>=30">重新测试</a>
      <a v-else style="background-color:#ccc">{{30-data.past_days}} 天后可重测</a> -->
    </div>
    <div class="ceping64_main">
      <h1 class="h1">
        价值观的重要性与满足度评估
      </h1>
      <h2 class="h2">
        为什么要明确工作价值观排序？
      </h2>
      <p class="p">
        面临与职业相关的诸多决策和取舍时，清楚自己价值观重要性地排序，会帮助自己作决策时更加坚定准确。追寻高薪和社会名声、助人的机会、增加职业安全感，还是更加独立？你也许每样都想要，但是鱼与熊掌不可兼得，你必须作出取舍。最好的方式就是在你的核心价值观的帮助下评估每一个选项，同时你需要评估当下环境中，哪一个选择对你更加重要。总之，清楚职业价值观提供了“什么对我最重要”这个问题的判断准则。
      </p>
      <h2 class="h2">
        为什么要明确工作对你价值观的满足程度？
      </h2>
      <p class="p">
        你的价值观决定了你对于职业、公司、企业文化、家庭和社区投入度的看法，这些看法进一步影响你的决策。而个人和周围的各种环境未必总是完美匹配的，如果你的工作忽略了价值观的满足，这种脱离可能会使你对工作失去兴趣，慢慢酝酿着不满或愤怒的情绪，对于公司也漠不关心，这就造成你和公司俱伤的局面；如果你的价值观和工作有紧密的联系，你会发现自己在达到目标的同时，也为公司贡献良多，你的工作就变成了使你既能成功又能幸福的双赢舞台。
      </p>
      <h2 class="h2">
        你的价值观重要性与满足度测量结果
      </h2>
      <p class="p">
        <b>重要性</b>：指的是您对各项价值观的重视程度。下表列出了排序情况，同时按照相对重要性划分为三档：较高重要性、中等重要性、较低重要性。值得注意的是，价值观的排序和重要性档次的划分是自我报告的结果，可以根据实际情况进行校准调整。
      </p>
      <p class="p">
        <b> 满足度</b>：指的是您的价值观在当前工作中获得满足的程度。分为三档：较高满足、中等满足、较低满足。
      </p>
      <div class="ceping64_mt">
        <div class="mt_t clearfix">
          <ul>
            <li>价值观</li>
            <li>重要性</li>
            <li>满足感</li>
          </ul>
        </div>
        <div class="mt_b clearfix" v-for="(item,index) in list" :key="index">
          <ul>
            <li>{{item.division}}</li>
            <li>
              <dl class="clearfix">
                <dd v-for="(it,idx) in 3" :class="item.importance>idx?'on':''" :key="idx"></dd>
              </dl>
            </li>
            <li>
              <dl class="clearfix">
                <dd v-for="(it,idx) in 3" :class="item.satisfaction>idx?'on':''" :key="idx"></dd>
              </dl>
            </li>
          </ul>
        </div>
      </div>
      <h1 class="h1">
        价值观九宫格
      </h1>
      <p class="p">
        因为受到多种因素影响，并不是每个人所重视的价值都能得到很好的满足。根据您的价值观重要性与满足程度测评结果，您的各项价值观在九宫格中呈现结果如下。
      </p>
      <img src="@a/ceping64_xp.png" class="img" alt="" />
      <p class="p">
        价值观在各个区的落点可以校准，建议仅在相邻格子间移动。总体而言，越靠右侧的格子内的价值观，其重要性越高，提升的必要性越大。我们建议你优先满足最重视的价值观，有时也可根据实际情况调整优先顺序。比如你可能认为“收入待遇”重要性不高，但是为了满足基本的物质需求，也可优先满足该价值观。
      </p>
      <h2 class="h2">
        重点关注区
      </h2>
      <p class="p">
        以下三个区是你需要关注的区域，下表列出了这些区域的描述和需要注意的问题，以及你在这三个区域的价值观。你可以利用这些信息，思考这些区域可能对你产生的影响，并制定策略达成你的目标。
      </p>
      <div class="area">
        <ul>
          <li v-for="(item,index) in data.focus_areas" :key="index">
            <h2>{{item.name}}<span>{{item.area}}</span></h2>
            <div class="clearfix">
              <div class="area_l">
                <h3>区域特点:</h3>
                <h4>{{item.feature}}</h4>
              </div>
              <div class="area_l">
                <h3>包括价值观：</h3>
                <h4 v-show="item.values.length>0" v-for="(itm,idx) in item.values" :key="idx">{{itm}}</h4>
                <h4 v-show="item.values.length==0">无</h4>
              </div>
            </div>
            <div class="area_b clearfix" v-for="(itm1,idx1) in item.desc" :key="idx1">
              <span></span>
              <div class="area_br">{{itm1}}</div>
            </div>
          </li>
        </ul>
      </div>
      <h2 class="h2" style="margin-bottom: 20px;">
        其他区域
      </h2>
      <div class="course_listnew">
        <ul>
          <li v-for="(item,index) in data.other_areas" :key="index" class="clearfix">
            <h2>
            <img src="@a/ceping64_d.png" alt=""/>
            {{item.area}} {{item.name}}
          </h2>
            <span class="line"></span>
            <div class="list_r">
              <h2 class="clearfix"><b>包括价值观：</b>
                <div class="h2_r">
                  <span v-for="(itm,idx) in item.values" :key="idx" v-show="item.values.length>0">{{itm}}</span>
                  <span v-show="item.values.length==0">无</span>
                </div>
              </h2>
              <h1><b>区域特点：</b>{{item.feature}}</h1>
            </div>
          </li>
        </ul>
      </div>
      <div class="button" @click="fill_emails=true">详细报告发至邮箱</div>
      <div class="bz">
        *本测评由新精英生涯（北京）教育科技有限公司版权所有，违者必究。
      </div>
    </div>
    <!-- 开启下一关卡 -->
    <div v-if="$route.query.level_list_id" class="levelbtn-group">
      <a @click="fill_emails=true" >将详细报告发送至邮箱</a>
      <a @click="list_link()" v-if="next.type == 1">开启“测评”</a>
      <a @click="list_link()" v-else-if="next.type == 2">开启下一课程</a>
      <a @click="list_link()" v-else-if="next.type == 3">开启“任务”</a>
      <a @click="list_link()" v-else-if="next.type == 5">去案例分析</a>
    </div>
    <van-popup v-model="fill_emails">
      <div class="confirm_box">
        <van-cell-group class="grouping">
          <van-field placeholder="请填写你的邮箱账号" v-model="mailbox" />
        </van-cell-group>
        <a class="cancel" href="javascript:;" @click="send_emails">确认</a>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { ceping64_report, ceping64_reset, sendPdf,getLevel} from "@/api/measurement";
import { shareCon} from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import { getLevel as getLevel2} from "@/api/course"

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
      return {
        body_show: false,
        data: {},
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: "",
          state: false,
          list: {},
          ct_img: [],
          pro_js: {}
        },
        ctime: '',
        fill_emails: false,
        mailbox: '',
        next:{},
        custom_logo: {}
      }
    },
    components:{
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
      /*
       *@param: 
       *@return: 
       *@Description: 开启下一个任务  1测评2音频3任务4小组讨论5案例
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-05 15:58:09
      */
      list_link() {
        let item = this.next;
        if (item.type == 1) {
          if(item.link.startsWith('http')){
            window.location.href = item.link+'?level_list_id=' + item.id;
          }else{
            this.$router.push({
              path:item.link,
              query:{
                level_list_id:item.id
              }
            })
          }
        } else if (item.type == 2) {
          this.$router.push('/course_content?cid=' + item.cid + '&level_list_id=' + item.id+'&cpid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 3) {
          this.$router.push(item.link + '?cid=' + item.cid + '&level_list_id=' + item.id+'&pid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 5) {
          this.$router.push('/case_analysis?id=' + item.id + '&level_list_id=' + item.id+'&cid=' + item.cid)
        }
      },
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        let q = this.$route.query;
        // 获取关卡信息
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        if(q.level_list_id){
          getLevel2({
            level_list_id:this.level_list_id
          }).then((data)=>{
            this.next = data.next;
          });
        }
        let ev_obj= {};
        if(q.evaluation_id || q.evaluation_id==0){
          ev_obj['evaluation_id'] = q.evaluation_id;
        }
        ceping64_report(ev_obj)
          .then((data) => {
            if (data.code == 10002) {
              let redirect_query = deepCopy(this.$route.query);
              if(redirect_query.evaluation_id) {
                delete redirect_query.evaluation_id;
              }
              this.$router.push({
                path:'/ceping64',
                query: redirect_query
              });
            } else if (typeof data !== 'string') {
              this.body_show = true;
              document.title = data.headtitle;
              this.ctime = data.ctime;
              this.list = data.list;
              this.data = data;
              this.state = data.state;
              this.nickname = data.nickname;
              this.type_obj.evaluation_id = this.$route.query.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = this.$route.query.uid;
              this.type_obj.nickname = data.nickname;
              this.type_obj.path = this.$route.path;

              // data.custom_logo = 'https://open-cdn.xjy.cn/static/uploads/73/512ca1d84dbe33a541976e5653e410.png';

              if(data.custom_logo) {
                this.custom_logo.backgroundImage = `url('${data.custom_logo}')`;
              }

              shareCon("ceping64", this, this.type_obj);
            } else {
              location.href = data;
            }
            //关闭加载中
            this.$emit('loadingHandle',false);
          })

      },
      reset() {
        this.$dialog.confirm({
          title: '重新测评',
          message: '您确认要重测吗？'
        }).then(() => {
          ceping64_reset()
            .then((data) => {
              this.$router.push("/ceping64")
            })
        }).catch(() => {
          // on cancel
        });
      },
      send_emails() {
        if (this.$Validator.isEmail(this.mailbox)) {
          //调用加载中
          this.$emit('loadingHandle',true,"发送中");
          let q = this.$route.query;
          let ev_obj= {
            cid: 64,
            touser: this.mailbox
          };
          if(q.evaluation_id || q.evaluation_id==0){
            ev_obj['evaluation_id'] = q.evaluation_id;
          }
          sendPdf(ev_obj)
            .then((data) => {
              //关闭加载中
              this.$emit('loadingHandle',false);
              this.$toast(data.msg);
              setTimeout(() => {
                this.fill_emails = false
              },200)
            }).catch(() => {
              //关闭加载中
              this.$emit('loadingHandle',false);
              this.$toast('报告发送可能有几分钟的延迟，请耐心等待。');
              setTimeout(() => {
                this.fill_emails = false
              },200)
        });
        } else {
          this.$toast('邮箱填写不正确！');
        }

      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
.body_show {
  padding-bottom: 185px;
  background-color: #fff;
}

.body_shows {
  padding-bottom: changeRem(2.96)+px;
}

.top {
  width: 100%;
  background: url(../../../assets/ceping_64_nologo.png) no-repeat top center;
  background-size: cover;
  height: 463px;
  padding: 0 28px;
  padding-top: 240px;
  color: #fff;
  position: relative;

  .custom-logo {
    width: 200px;
    height: 100px;
    position: absolute;
    top: 25px;
    right: 25px;
    // border: 1px solid #000;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top right;
  }

  h1 {
    font-size: 50px;
    font-weight: bold;
  }
  h2 {
    font-size: 24px;
    margin-top: 10px;
  }
  h3 {
    font-size: 24px;
    margin-top: 10px;
  }
  a {
    display: block;
    margin-top: 40px;
    width: 240px;
    height: 55px;
    background: #0D2589;
    border-radius: 8px;
    font-size: 30px;
    color: #fff;
    line-height: 55px;
    text-align: center;
  }
}

.ceping64_main {
  padding: 0 30px;
  text-align: center;
  h1.h1 {
    font-size: 38px;
    color: #F28C24;
    text-align: justify;
    margin-top: 80px;
  }
  h2.h2 {
    font-size: 30px;
    color: #333;
    text-align: justify;
    margin-top: 60px;
    font-weight: bold;
  }
  p.p {
    font-size: 26px;
    color: #333;
    text-align: justify;
    margin-top: 30px;
    line-height: 40px;
  }
  img.img {
    margin: 0 auto;
    margin-top: 80px;
    width: 610px;
  }
  .ceping64_mt {
    margin-top: 100px;
    padding: 0 10px;
    padding-bottom: 100px;
    border-bottom: 2px dashed #F28C24;
    .mt_t {
      margin-bottom: 20px;
      ul li {
        width: 214px;
        margin-left: 60px;
        text-align: center;
        font-size: 30px;
        color: #333;
        float: left;
        font-weight: bold;
      }
      ul li:first-child {
        width: 104px;
        margin-left: 0;
      }
    }
    .mt_b {
      ul li {
        margin-top: 30px;
        font-size: 26px;
        color: #333;
        width: 214px;
        margin-left: 60px;
        text-align: center;
        float: left;
        dl {
          margin-top: 10px;
          dd {
            width: 70px;
            float: left;
            margin-left: 2px;
            height: 18px;
            background-color: #F2F2F2;
          }
          dd:first-child {
            margin-left: 0;
          }
          dd.on {
            background-color: #F28C24
          }
        }
      }
      ul li:first-child {
        width: 104px;
        margin-left: 0;
      }
      ul li:last-child {
        dl dd.on {
          background-color: #6C6C6C
        }
      }
    }
  }
  .area {
    ul li {
      margin-top: 50px;
      width: 690px;
      border: 3px solid rgba(108, 108, 108, 1);
      border-radius: 12px;
      h2 {
        line-height: 90px;
        background: rgba(108, 108, 108, 1);
        border-radius: 12px 12px 1px 0px;
        font-size: 34px;
        color: #fff;
        position: relative;
        span {
          position: absolute;
          top: 0;
          right: 30px;
          font-size: 24px;
          color: #fff;
        }
      }
      .area_l {
        width: 340px;
        padding: 26px;
        height: 208px;
        background-color: #F8C491;
        float: left;
        text-align: left;
        h3 {
          font-size: 26px;
          color: #333;
          font-weight: bold;
        }
        h4 {
          font-size: 26px;
          color: #333;
          display: inline-block;
          margin-right: 30px;
          margin-top: 10px;
        }
      }
      .area_l:last-child {
        background-color: #FEF4EA
      }
      .area_b {
        position: relative;
        padding: 30px;
        span {
          position: absolute;
          top: 50px;
          left: 36px;
          width: 10px;
          height: 10px;
          background-color: #333;
          border-radius: 50%;
        }
        .area_br {
          width: 588px;
          float: right;
          line-height: 40px;
          font-size: 26px;
          color: #333;
          text-align: justify;
        }
      }
    }
  }
  .course_listnew {
    width: 100%;
    height: auto;
    ul {
      li {
        width: 100%;
        padding: 30px 0;
        padding-bottom: 0;
        text-align: left;
        position: relative;
        h2 {
          color: #F28B24;
          font-size: 30px;
          line-height: 24px;
          img {
            width: 12px;
            margin-right: 30px;
          }
        }
        span.line {
          position: absolute;
          left: 5px;
          top: 0;
          width: 2px;
          background-color: #F28B24;
          height: 100%;
        }
        .list_r {
          float: right;
          width: 680px;
          background: #FEF4EA;
          margin-top: 20px;
          padding: 30px 32px;
          position: relative;
          h1 {
            color: #333;
            font-size: 26px;
            line-height: 40px;
            margin-top: 30px;
          }
          h2 {
            color: #333;
            padding-bottom: 30px;
            border-bottom: 2px dashed #F28C24;
            line-height: 50px;
            .h2_r {
              color: #333;
              font-size: 26px;
              line-height: 50px;
              width: 420px;
              float: right;
              span {
                margin-right: 10px;
                display: inline-block;
              }
            }
          }
        }
      }
      li:first-child {
        padding-top: 10px;
      }
    }
  }
  .bz {
    margin-top: 60px;
    font-size: 24px;
    color: #999;
    text-align: justify;
  }
  .button {
    width: 100%;
    line-height: 98px;
    text-align: center;
    color: #fff;
    background-color: #EB5032;
    font-size: 34px;
    margin-top: 60px;
    border-radius: 12px;
  }
}

.confirm_box {
  padding: 50px 40px;
  border-radius: 12px;
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box a.cancel {
  color: #fff;
  background-color: #EB5032;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  border-radius: 8px
}

.grouping .van-cell .van-cell__value input {
  border: 2px solid #ccc;
  border-radius: 12px;
  font-size: 26px;
  color: #333;
}
// 关卡信息
.levelbtn-group{
  display: flex;
  line-height: 98px;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 50%;
  max-width: 750px;
  transform: translateX(-50%);
  z-index: 998;
  background-color: #EB5032;
  a{
    flex: 1;
    display: block;
    text-align: center;
    font-size: 32px;
    color: #ffffff;
    &:nth-child(1){
      border-right: 1px solid #ffffff;
    }
    &:last-child{
      border-left: 1px solid #ffffff;
    }
  }
}
</style>
